export default "__VITE_ASSET__DMu0obIj__"